/* eslint-disable */
import { aggregateRw, defaultRecalcParams, RECALC_STORAGE_KEY, reweight } from '../../../FeederScore/recomputeFeederScore';
/**
 * Presentación de indicadores de alimentación y Feeder Score.
 *
 * Estos métodos operan sobre la instancia de PanelLogic y conservan el
 * contrato del prototipo importado. No mantienen estado global propio.
 */
const logic = {
  scoreC(v, c) {
    if (!Number.isFinite(v)) return '#8793a6';
    if (!Number.isFinite(c)) c = v;
    const d = Math.max(-1, Math.min(1, (v - c) / 25));
    return d >= 0 ? 'oklch(' + (0.74 + 0.08 * d).toFixed(3) + ' ' + (0.06 + 0.12 * d).toFixed(3) + ' 140)' : 'oklch(' + (0.74 - 0.06 * -d).toFixed(3) + ' ' + (0.06 + 0.13 * -d).toFixed(3) + ' 30)';
  },
  fsVals(st) {
    const D = this.data,
      SD = this.scoreData(),
      N = D.days.length,
      per = st.fsPer || 30,
      met = st.fsMet || 'score';
    const end = per === 'all' ? N - 1 : Math.max(Math.min(N - 1, st.day), Math.min(N - 1, per - 1)),
      start = per === 'all' ? 0 : Math.max(0, end - per + 1),
      resolution = this.props.groupMode || 'day',
      recalcParams = this.props.scoreRecalcParams;
    const periodLabel = indices => {
      const first = D.days[indices[0]];
      if (resolution === 'day') return first;
      if (resolution === 'month') return first.slice(3);
      const date = new Date(+first.slice(6), +first.slice(3, 5) - 1, +first.slice(0, 2));
      date.setDate(date.getDate() - (date.getDay() + 6) % 7);
      const finish = new Date(date);
      finish.setDate(finish.getDate() + 6);
      const ddmm = value => String(value.getDate()).padStart(2, '0') + '/' + String(value.getMonth() + 1).padStart(2, '0');
      return ddmm(date) + '–' + ddmm(finish);
    };
    const periods = this.periodBuckets(false)
      .map(indices => indices.filter(index => index >= start && index <= end))
      .filter(indices => indices.length)
      .map(indices => ({ indices, label: periodLabel(indices), day: indices[indices.length - 1] }));
    const aggregateCell = (ci, period) => {
      const items = period.indices.map(index => SD.M[ci][index]).filter(Boolean);
      if (!items.length) return null;
      const scores = items.map(item => item.score).filter(Number.isFinite);
      let score = scores.length ? scores.reduce((sum, value) => sum + value, 0) / scores.length : null;
      let rw = items.at(-1)?.rw || null;
      if (resolution !== 'day' && recalcParams?.mode === 'standard') {
        rw = aggregateRw(items.map(item => item.rw), recalcParams.aggregation);
        const recalculated = reweight(rw, recalcParams);
        if (Number.isFinite(recalculated)) score = Number(recalculated.toFixed(2));
      }
      const rs = items.flatMap(item => item.rs || []).filter(Number.isFinite);
      const reacts = items.map(item => item.react).filter(Number.isFinite);
      const sfrValues = items.map(item => item.sfr).filter(Number.isFinite);
      return {
        ...items.at(-1),
        score,
        al: items.reduce((sum, item) => sum + item.al, 0),
        att: items.reduce((sum, item) => sum + item.att, 0),
        kg: items.reduce((sum, item) => sum + item.kg, 0),
        react: rs.length ? rs.reduce((sum, value) => sum + value, 0) / rs.length : reacts.length ? reacts.reduce((sum, value) => sum + value, 0) / reacts.length : null,
        rs,
        rw,
        sfr: sfrValues.length ? sfrValues.reduce((sum, value) => sum + value, 0) / sfrValues.length : NaN,
        ppa: items.reduce((sum, item) => sum + (Number.isFinite(item.ppa) ? item.ppa : 0), 0),
        comp: {},
      };
    };
    const nD = periods.length,
      val = c => !c ? null : met === 'score' ? c.score : met === 'att' ? c.al ? c.att / c.al * 100 : null : c.react;
    const fmtR = s => Math.floor(s / 60) + 'm ' + String(Math.round(s % 60)).padStart(2, '0') + 's';
    const fmt = (v, short) => !Number.isFinite(v) ? '–' : met === 'score' ? v.toFixed(short ? 0 : 1) : met === 'att' ? Math.round(v) + '%' : short ? Math.floor(v / 60) + ':' + String(Math.round(v % 60)).padStart(2, '0') : fmtR(v);
    const cells = D.rows.map((_, ci) => periods.map(period => aggregateCell(ci, period)));
    const vals = cells.flat().map(val).filter(Number.isFinite),
      mean = vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
    const dev = vals.map(v => Math.abs(v - mean)).sort((a, b) => a - b),
      spread = Math.max(1e-6, dev[Math.floor(dev.length * 0.95)] || 1),
      better = met === 'react' ? -1 : 1;
    const colr = v => {
      if (v == null) return 'transparent';
      const k = Math.max(-1, Math.min(1, (v - mean) / spread * better));
      return k >= 0 ? 'oklch(0.62 0.15 140 / ' + (0.1 + 0.6 * k).toFixed(2) + ')' : 'oklch(0.6 0.19 25 / ' + (0.1 + 0.62 * -k).toFixed(2) + ')';
    };
    const txtC = v => {
      if (v == null) return '#3a4558';
      const k = (v - mean) / spread * better;
      return k > 0.35 ? 'oklch(0.88 0.12 140)' : k < -0.35 ? 'oklch(0.86 0.1 30)' : '#b8c1ce';
    };
    const hov = st.fsHov,
      sel = st.fsSel || {
        ci: st.sel,
        d: null
      },
      showN = nD <= 36;
    const fsRows = D.rows.map((row, ci) => ({
      name: row.name,
      nC: ci === sel.ci ? '#e4e9f0' : '#b8c1ce',
      fw: ci === sel.ci ? 600 : 400,
      rowBg: hov && hov.ci === ci ? 'rgba(46,179,238,0.05)' : 'transparent',
      cells: periods.map((period, j) => {
        const c = cells[ci][j],
          v = val(c),
          hasValue = Number.isFinite(v),
          on = sel.ci === ci && sel.d != null && period.indices.includes(sel.d);
        return {
          bg: hasValue ? colr(v) : 'transparent',
          t: showN && hasValue ? fmt(v, true) : '',
          tc: txtC(v),
          ol: on ? "0.092593vh solid #e4e9f0" : hov && hov.ci === ci && hov.j === j ? "0.092593vh solid rgba(228,233,240,0.5)" : 'none',
          bd: hasValue ? 'none' : "0.092593vh dashed rgba(42,52,70,0.6)",
          enter: () => this.setState({
            fsHov: {
              ci,
              j
            }
          }),
          click: () => this.setState({
            fsSel: {
              ci,
              d: period.day
            }
          })
        };
      })
    }));
    const step = nD > 40 ? 4 : nD > 20 ? 2 : 1;
    const fsHead = periods.map((period, j) => ({
      lab: j % step === 0 ? period.label : '',
      c: period.indices.includes(st.day) ? 'oklch(0.78 0.12 250)' : hov && hov.j === j ? '#e4e9f0' : '#8793a6'
    }));
    let fsTip = {
      on: false,
      rows: []
    };
    if (hov && hov.j < nD) {
      const c = cells[hov.ci][hov.j],
        f = (hov.j + 0.5) / nD;
      fsTip = {
        on: true,
        title: D.cages[hov.ci] + ' · ' + periods[hov.j].label,
        left: "calc(3.75vw + (100% - 3.75vw) * " + f.toFixed(4) + ')',
        top: ((hov.ci + 0.5) / D.rows.length * 100).toFixed(2) + '%',
        tx: f > 0.6 ? "translate(calc(-100% - 0.729167vw),-50%)" : "translate(0.729167vw,-50%)",
        rows: !c ? [{
          l: 'Ayuno',
          c: '#8793a6',
          v: 'sin período'
        }] : [{
          l: 'Score',
          c: '#b8c1ce',
          v: fmt(c.score),
          vc: this.scoreC(c.score, SD.flat)
        }, {
          l: 'Atención',
          c: '#b8c1ce',
          v: c.al ? Math.round(c.att / c.al * 100) + '%' : '–'
        }, {
          l: 'Alimento',
          c: '#b8c1ce',
          v: c.kg.toLocaleString('es-CL', {
            maximumFractionDigits: 1
          }) + ' kg'
        }, {
          l: 'Alarmas (no atend.)',
          c: '#b8c1ce',
          v: c.al + ' (' + (c.al - c.att) + ')'
        }, {
          l: 'Reacción',
          c: '#b8c1ce',
          v: c.react == null ? '–' : fmtR(c.react)
        }].map(x => ({
          vc: '#e4e9f0',
          ...x
        }))
      };
    }
    const flatC = cells.flat().filter(Boolean),
      scoreCells = flatC.filter(c => Number.isFinite(c.score)),
      kgT = scoreCells.reduce((a, c) => a + Math.max(0, c.kg), 0),
      alT = flatC.reduce((a, c) => a + c.al, 0),
      atT = flatC.reduce((a, c) => a + c.att, 0),
      rsA = flatC.flatMap(c => c.rs).sort((a, b) => a - b);
    const scW = kgT ? scoreCells.reduce((a, c) => a + c.score * Math.max(0, c.kg), 0) / kgT : null,
      scF = scoreCells.length ? scoreCells.reduce((a, c) => a + c.score, 0) / scoreCells.length : null,
      scs = scoreCells.map(c => c.score),
      scoredRows = D.rows.filter((_, ci) => cells[ci].some(c => Number.isFinite(c?.score))).length;
    const kp = (k, l, v, s1, s2, vc) => ({
      l,
      v,
      s1,
      s2,
      vc,
      bd: met === k ? 'oklch(0.75 0.13 230 / 0.6)' : 'rgba(46,179,238,0.12)',
      bg: met === k ? 'rgba(46,179,238,0.1)' : 'transparent',
      onClick: k ? () => this.setState({
        fsMet: k
      }) : null,
      cur: k ? 'pointer' : 'default'
    });
    const fsKpis = [kp(null, 'Períodos analizados', String(nD), scoredRows + ' jaulas', scoreCells.length + ' puntuaciones', '#e4e9f0'), kp('score', 'Score', scW == null ? '–' : scW.toFixed(1), 'Rango ' + (scs.length ? Math.min(...scs).toFixed(1) + '–' + Math.max(...scs).toFixed(1) : '–'), 'Promedio plano ' + (scF == null ? '–' : scF.toFixed(1)), this.scoreC(scW, SD.flat)), kp('att', 'Alarmas atendidas', alT ? (atT / alT * 100).toFixed(1).replace('.', ',') + '%' : '–', 'Atendidas ' + atT, 'Totales ' + alT, alT && atT / alT < 0.3 ? 'oklch(0.72 0.17 25)' : '#e4e9f0'), kp('react', 'Reacción a alarmas', rsA.length ? fmtR(rsA.reduce((a, b) => a + b, 0) / rsA.length) : '–', rsA.length ? 'p95 ' + fmtR(rsA[Math.floor(rsA.length * 0.95)]) : 'sin atendidas', '', '#e4e9f0')];
    const agg = ci => {
      const v = cells[ci].filter(Boolean);
      if (!v.length) return null;
      if (met === 'att') {
        const a = v.reduce((s, c) => s + c.al, 0);
        return a ? v.reduce((s, c) => s + c.att, 0) / a * 100 : null;
      }
      if (met === 'react') {
        const r = v.flatMap(c => c.rs);
        return r.length ? r.reduce((a, b) => a + b, 0) / r.length : null;
      }
      const scores = v.map(c => c.score).filter(Number.isFinite);
      return scores.length ? scores.reduce((s, score) => s + score, 0) / scores.length : null;
    };
    const rk = D.rows.map((row, ci) => ({
      ci,
      name: row.name,
      v: agg(ci)
    })).filter(x => Number.isFinite(x.v)).sort((a, b) => (b.v - a.v) * better);
    const rMx = Math.max(1e-6, ...rk.map(x => x.v));
    const fsRank = rk.map((x, i) => {
      const ser = cells[x.ci].map(val),
        latestJ = ser.reduce((latest, value, j) => Number.isFinite(value) ? j : latest, -1),
        pts = ser.map((v, j) => v == null ? null : [j / Math.max(1, nD - 1) * 100, v]).filter(Boolean);
      const lo = Math.min(...vals),
        hi = Math.max(...vals),
        Y = v => (28 - (v - lo) / Math.max(1e-6, hi - lo) * 24).toFixed(1);
      return {
        n: String(i + 1),
        name: x.name,
        v: fmt(x.v),
        vc: met === 'score' ? this.scoreC(x.v, SD.flat) : txtC(x.v),
        w: (met === 'react' ? (1 - x.v / rMx) * 70 + 30 : x.v / rMx * 100).toFixed(1) + '%',
        bc: met === 'score' ? this.scoreC(x.v, SD.flat) : colr(x.v),
        spark: pts.length ? pts.map((p, k) => (k ? 'L' : 'M') + p[0].toFixed(1) + ' ' + Y(p[1])).join(' ') : 'M0 0',
        mid: 'M0 ' + Y(mean) + ' H100',
        bg: x.ci === sel.ci ? 'rgba(46,179,238,0.12)' : 'transparent',
        onClick: () => this.setState({
          fsSel: {
            ci: x.ci,
            d: latestJ >= 0 ? periods[latestJ].day : null
          },
          fsDetailOpen: false
        })
      };
    });
    const selectedPeriod = sel.d != null ? periods.findIndex(period => period.indices.includes(sel.d)) : -1,
      sc = selectedPeriod >= 0 ? cells[sel.ci][selectedPeriod] : null,
      sv = cells[sel.ci].filter(Boolean);
    const metricCells = sc ? [sc] : sv,
      metricKg = metricCells.reduce((sum, cell) => sum + Math.max(0, Number(cell.kg) || 0), 0),
      metricAlarms = metricCells.reduce((sum, cell) => sum + (Number(cell.al) || 0), 0),
      metricAttended = metricCells.reduce((sum, cell) => sum + (Number(cell.att) || 0), 0),
      metricUnattended = Math.max(0, metricAlarms - metricAttended),
      metricAttention = metricAlarms ? metricAttended / metricAlarms * 100 : null,
      reactionSamples = metricCells.flatMap(cell => cell.rs || []).filter(Number.isFinite),
      reactionMeans = metricCells.map(cell => cell.react).filter(Number.isFinite),
      metricReaction = reactionSamples.length
        ? reactionSamples.reduce((sum, value) => sum + value, 0) / reactionSamples.length
        : reactionMeans.length
          ? reactionMeans.reduce((sum, value) => sum + value, 0) / reactionMeans.length
          : null,
      qualityValues = metricCells
        .filter(cell => cell.Q != null)
        .map(cell => Number(cell.Q) * 100)
        .filter(Number.isFinite),
      metricQuality = qualityValues.length ? qualityValues.reduce((sum, value) => sum + value, 0) / qualityValues.length : null,
      metricColor = value => value == null ? '#5a667a' : value < 50 ? '#ff625f' : value < 80 ? 'oklch(0.82 0.15 85)' : 'oklch(0.82 0.16 140)',
      fsComp = [{
        l: 'Alimento entregado',
        v: metricKg.toLocaleString('es-CL', { maximumFractionDigits: 1 }) + ' kg',
        c: '#e4e9f0'
      }, {
        l: 'Alarmas atendidas',
        v: metricAttention == null ? '–' : Math.round(metricAttention) + '%',
        c: metricColor(metricAttention)
      }, {
        l: 'Alarmas (no atend.)',
        v: metricAlarms + ' (' + metricUnattended + ')',
        c: '#e4e9f0'
      }, {
        l: 'Reacción a alarmas',
        v: metricReaction == null ? '–' : fmtR(metricReaction),
        c: metricReaction == null ? '#5a667a' : '#e4e9f0'
      }, {
        l: 'Calidad',
        v: metricQuality == null ? '–' : metricQuality.toLocaleString('es-CL', { maximumFractionDigits: 1 }) + '%',
        c: metricQuality == null ? '#5a667a' : '#e4e9f0'
      }];
    const selectedScores = sv.map(c => c.score).filter(Number.isFinite),
      selScore = sc ? (Number.isFinite(sc.score) ? sc.score : null) : selectedScores.length ? selectedScores.reduce((a, score) => a + score, 0) / selectedScores.length : null,
      detailAvailable = this.props.nivelSeleccionado === 'centro' && resolution === 'day' && Array.isArray(sc?.cycles) && sc.cycles.length > 0;
    const seg = (list, cur, field) => list.map(([k, label]) => ({
      label,
      bg: cur === k ? 'rgba(46,179,238,0.16)' : 'transparent',
      color: cur === k ? '#e4e9f0' : '#8793a6',
      fw: cur === k ? 600 : 400,
      onClick: () => this.setState({
        [field]: k,
        fsHov: null
      })
    }));
    return {
      fsRows,
      fsHead,
      fsTip,
      fsKpis,
      fsRank,
      fsComp,
      fsCols: "3.75vw repeat(" + nD + ', minmax(0,1fr))',
      fsMets: seg([['score', 'Score'], ['att', '% Atención'], ['react', 'Reacción']], met, 'fsMet'),
      fsPers: seg([[7, '7 d'], [14, '14 d'], [30, '30 d'], ['all', 'Todo']], per, 'fsPer'),
      fsSub: D.days[start] + ' – ' + D.days[end] + ' · ' + (end - start + 1) + ' días · ' + ({ day: 'día', week: 'semana', month: 'mes' }[resolution] || 'día'),
      fsLeave: () => this.setState({
        fsHov: null
      }),
      fsLegL: met === 'react' ? 'más lenta' : 'bajo el promedio',
      fsLegR: met === 'react' ? 'más rápida' : 'sobre el promedio',
      fsLegM: fmt(mean),
      fsRankT: met === 'score' ? 'Ranking · score' : met === 'att' ? 'Ranking · % atención' : 'Ranking · reacción (más rápida primero)',
      fsSelT: D.cages[sel.ci] + (selectedPeriod >= 0 ? ' · ' + periods[selectedPeriod].label : ' · promedio del período'),
      fsSelV: selScore == null ? '–' : selScore.toFixed(1),
      fsSelC: selScore == null ? '#8793a6' : this.scoreC(selScore, SD.flat),
      fsWeak: '',
      fsDetailAvailable: detailAvailable,
      fsDetailOpen: Boolean(st.fsDetailOpen && detailAvailable),
      fsDetailData: detailAvailable ? sc : null,
      fsDetailDay: detailAvailable ? periods[selectedPeriod].label : '',
      fsOpenDetail: detailAvailable ? () => this.setState({
        fsDetailOpen: true
      }) : null,
      fsCloseDetail: () => this.setState({
        fsDetailOpen: false
      }),
      fsGoDet: () => this.setState({
        view: 'panel',
        sel: sel.ci,
        ...(sel.d != null ? {
          day: sel.d
        } : {})
      }),
      fsRecalcActive: Boolean(this.props.scoreRecalcParams),
      fsRecalcOpen: Boolean(st.fsRecalcOpen),
      fsRecalcParams: this.props.scoreRecalcParams || null,
      fsRecalcDefaults: defaultRecalcParams(),
      fsRecalcLevel: this.props.nivelSeleccionado || 'centro',
      fsRecalcGroup: this.props.groupMode || 'day',
      fsRecalc: () => this.setState({ fsRecalcOpen: true }),
      fsRecalcClose: () => this.setState({ fsRecalcOpen: false }),
      fsRecalcApply: params => {
        this.props.setScoreRecalcParams?.(params);
        this.setState({ fsRecalcOpen: false });
      },
      fsRecalcOriginal: () => {
        this.props.setScoreRecalcParams?.(null);
        this.setState({ fsRecalcOpen: false });
      },
      fsRecalcReset: () => {
        try { window.localStorage.removeItem(RECALC_STORAGE_KEY); } catch (_error) {}
      }
    };
  }
};
export default logic;
